export const en = {
  
  common: {
    loading: "Loading...",
    error: "Error",
    success: "Success",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    back: "Back",
    filter: "Filter Projects",
    all: "All",
    search: "Search",
    noResults: "No results found",
    confirm: "Confirm",
    close: "Close",
    comments: "Comments",
    select: "Select",
    tool: "Tool",
    color: "Color",
    clear: "Clear",
    deleteSelected: "Delete Selected",
    changeColor: "Change Color",
    undo: "Undo",
    redo: "Redo",
    resize: "Resize",
    drawingDisabledWhileViewingComment:
      "Drawing tools are disabled while a comment is selected"
  },
  projects: {
    title: "Project Folders",
    newProject: "New Project",
    newFolder: "New Folder",
    newFile: "New File",
    projectName: "Project Name",
    folderName: "Folder Name",
    fileName: "File Name",
    status: "Status",
    share: "Share With",
    creationDate: "Creation Date",
    lastUpdate: "Last Update",
    users: "Users",
    sortBy: "Sorted by",
    statusOptions: {
      needsreview: "Needs Review",
      updated: "Updated",
      approved: "Approved"
    },
    sortOptions: {
      createdAtDesc: "Creation Date (Newest First)",
      createdAtAsc: "Creation Date (Oldest First)",
      updatedAtDesc: "Last Update (Newest First)",
      updatedAtAsc: "Last Update (Oldest First)",
      entryTypeAsc: "Entry Type (A-Z)",
      entryTypeDesc: "Entry Type (Z-A)",
      statusAsc: "Status (A-Z)",
      statusDesc: "Status (Z-A)"
    },
    fileUpload: {
      uploadFile: "Upload File",
      selectFile: "Please select a file.",
      fileSizeExceeded: "File size cannot exceed 500MB.",
      fileUpdated: "File could not be updated.",
      fileCreated: "File could not be created.",
      updateError: "An error occurred while updating the file.",
      uploadError: "An error occurred while uploading the file.",
      dragAndDrop: "Drag and drop your file here or click",
      singleFile: "You can upload a single file",
      maxSize: "File size cannot exceed 100MB"
    },
    duplicateSuccess: "Duplicated successfully",
    duplicatePartialSuccess:
      "Copy was created in the current folder but could not be moved to the selected destination.",
    moveSuccess: "Moved successfully.",
    move: "Move",
    duplicate: "Duplicate",
    bulkMoving: "Moving",
    bulkDuplicating: "Duplicating",
    bulkMoveSuccess: "Moved successfully.",
    bulkDuplicateSuccess: "Duplicated successfully.",
    bulkMovePartial: "Some items could not be moved.",
    bulkDuplicatePartial: "Some items could not be duplicated.",
    fileMergeSuccess: "Moved to file successfully.",
    fileMergeInProgress: "Moving to file...",
    fileMergeActive: "Move to file",
    folderDropActive: "Move here",
    /** Liste boş ve kullanıcı proje oluşturamaz (ör. Viewer); erişim reddi mesajı değil */
    noProjectsYetTitle: "No projects yet",
    noProjectsYetHint:
      "This page is empty. Updates will appear here as your projects progress.",
    errors: {
      selectFile: "Please select a file.",
      projectNotFound: "Project not found",
      folderNotFound: "Folder not found",
      fileNotFound: "File not found",
      createProjectError: "Failed to create project",
      createFolderError: "Failed to create folder",
      createFileError: "Failed to create file",
      uploadError: "Upload failed",
      invalidFileSize: "File size exceeds the limit",
      sameFileNameExists: "A file with the same name already exists. You cannot add a file with the same name.",
      invalidTarget: "Invalid destination.",
      moveError: "Failed to move.",
      mergeMultipleVersions: "Files with more than one version cannot be merged."
    }
  },
  breadcrumb: {
    projects: "Projects",
    currentLocation: "Current Location"
  },
  datePicker: {
    startDate: "Start Date",
    endDate: "End Date"
  },
  settings: {
    title: 'Settings',
    userSettings: 'User Settings',
    accountSettings: 'Account Settings',
    userSettingsContent: 'User settings content will be here.',
    accountSettingsContent: 'Account settings content will be here.',
    newUser: 'New User'
  },
  projectDetail: {
    title: "Project Detail",
    back: "Back",
    sortBy: "Sorted by",
    date: "Date",
    dateAll: "All",
    dateMonth: "Month",
    dateQuarter: "Quarter",
    dateYear: "Year",
    organization: "Organization",
    organizationName: "Organization Name",
    name: "Name",
    userName: "User Name",
    emailSuggestEmpty: "No matching emails",
    sortNameAsc: "Name (A-Z)",
    sortNameDesc: "Name (Z-A)",
    sortDateNewest: "Date (Newest)",
    sortDateOldest: "Date (Oldest)",
    sortFieldCreationDate: "Creation Date",
    sortFieldOrganization: "Organization",
    sortFieldName: "Name",
    sortFieldNumberOfFiles: "Number of Files",
    sortFieldStatus: "Status",
    sortDirNewToOld: "New to Old",
    sortDirOldToNew: "Old to New",
    sortDirAToZ: "A to Z",
    sortDirZToA: "Z to A",
    sortDirAsc: "Asc",
    sortDirDesc: "Desc",
    newEntry: "Upload",
    createFolder: "Create Folder",
    createFile: "Create File",
    rename: "Rename",
    changeThumbnail: "Change thumbnail",
    noContent: "No content in this folder",
    emptyProjectHeading: "Empty Project",
    emptyFolderHeading: "Empty Folder",
    emptyStateTitle: "No entries found",
    emptyStateHint:
      "Drag & drop your files here, or click \"Upload File\" to add them.",
    emptyStateHintViewer: "There are no files or folders to display here.",
    emptyStateUploadFile: "Upload File",
    totalEntryCount: "Entry",
    totalProjectCount: "Projects",
    projectNotFound: "Project or folder could not be found.",
    projectNotFoundHint:
      "The path may be incorrect, the item may have been moved, or you may not have access.",
    accessDenied: "You don't have permission to view this page.",
    accessDeniedHint:
      "You don't have access to this location, or the link is no longer valid.",
    loading: "Loading...",
    sortOptions: {
      createdAtDesc: "Creation Date (Newest First)",
      createdAtAsc: "Creation Date (Oldest First)",
      updatedAtDesc: "Last Update (Newest First)",
      updatedAtAsc: "Last Update (Oldest First)",
      entryTypeAsc: "Entry Type (A-Z)",
      entryTypeDesc: "Entry Type (Z-A)",
      statusAsc: "Status (A-Z)",
      statusDesc: "Status (Z-A)"
    }
  },
  fileDetail: {
    loading: "Loading...",
    accessDenied: "You don't have permission to view this file.",
    accessDeniedHint:
      "You don't have permission to access this file or its versions, or the link is no longer valid.",
    fileNotFound: "File not found",
    fileNotFoundHint:
      "The file may have been moved, deleted, or is no longer available.",
    noSharedVersionTitle: "No shared versions to display",
    noSharedVersionHint:
      "No version of this file has been shared with you. At least one version must be shared for you to view it.",
    goBack: "Go Back",
    back: "Back",
    siblingFileNavPrev: "Previous file",
    siblingFileNavNext: "Next file",
    siblingFileNavPrevHint: "Previous file (←)",
    siblingFileNavNextHint: "Next file (→)",
    siblingFileNavKeyboardHint: "Use left and right arrow keys to switch files",
    download: "Download",
    share: "Share",
    fileInformation: "File Information",
    fileName: "File Name",
    fileType: "File Type",
    fileSize: "File Size",
    status: "Status",
    createdAt: "Created At",
    updatedAt: "Updated At",
    sharedWith: "Shared With",
    noOrganization: "No Organization",
    videoNotSupported: "Your browser does not support the video tag.",
    previewNotAvailable: "Preview not available for this file type",
    downloadFile: "Download File"
  },
  uploadProgress: {
    uploading: "Uploading...",
    duplicating: "Duplicating",
    complete: "Upload complete",
    cancel: "Cancel",
    done: "done",
    error: "error",
    untitledEntry: "Untitled Entry",
    untitledFolder: "Untitled Folder",
    oneFile: "1 file",
    files: "files"
  },
  downloadProgress: {
    downloading: "Downloading..."
  },
  uploadLeaveWarning: {
    title: "Upload in progress",
    message: "Your changes may not have been saved. Are you sure you want to leave? Ongoing uploads may be interrupted.",
    leave: "Leave"
  }
}; 